import ClipboardButton from '~/javascripts/behaviors/ClipboardButton';
import LinkIcon from '~/images/icons/copy-link-icon-bg-yellow.png';
import { observer } from 'mobx-react';
import { useLayoutEffect } from 'react';

const UrlCopyLinkBlock = observer(({ campaignUrl }) => {
  useLayoutEffect(() => {
    ClipboardButton($('.clipboard-button'));
  }, []);

  return (
    <div className='theme-maji url-copy-link-block flex flex-row items-start justify-between border border-solid border-grey-30 rounded p-2 bg-cw-white text-left'>
      <div className='w-3/4'>
        <h1 className='h60'>Spread the word</h1>
        <p className='p40 mx-auto balance-text mt-1'>
          Share this fundraiser with friends and family to help spread the word
          to more&nbsp;people.
        </p>
      </div>
      <div className='flex flex-col md-flex-row justify-between items-center mb-2'>
        <div
          className='clipboard-button w-full mt-1 md-mt-0'
          data-behavior='ClipboardButton'
        >
          <a
            className='btn no-underline flex flex-col items-center justify-center'
            data-clipboard-text={campaignUrl}
          >
            <img className='mb-1' height='60px' src={LinkIcon} width='60px' />
            <p className='p40 text-xs text-cw-black'>Copy link</p>
          </a>
        </div>
      </div>
    </div>
  );
});

export default UrlCopyLinkBlock;
